<template>
  <div class="footer-menu py-5">
    <div class="container">
      <div class="row border-top border-3 border-black pt-2 main-section">
        <div class="col-12 col-md-4 col-lg-3 py-4  address-section" v-if="typeof contactData == 'object'">
          <h5 class="d-none d-md-block">{{ contactData.title }}</h5>
          <h5 class="d-block d-md-none">
            <a class="collapse-toggle d-flex justify-content-between align-items-center" data-toggle="collapse" href="#footer-address" role="button" aria-expanded="false" aria-controls="footer-address">
              <span>{{ contactData.title }}</span>
              <ClientOnly><i class="fa-solid fa-angle-down"></i></ClientOnly>
            </a>
          </h5>
          <div class="collapse mt-4 pt-2" id="footer-address">
            <cmsBlockSimple
              v-if="typeof contactData == 'object'"
              :identifier="contactData.identifier"
            />
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-4 py-4  general-info">
          <h5 class="d-none d-md-block">{{ generalInfoFooter.title }}</h5>
          <h5 class="d-block d-md-none">
            <a class="collapse-toggle d-flex justify-content-between align-items-center" data-toggle="collapse" href="#footer-general-info" role="button" aria-expanded="false" aria-controls="footer-general-info">
              <span>{{ generalInfoFooter.title }}</span>
              <ClientOnly><i class="fa-solid fa-angle-down"></i></ClientOnly>
            </a>
          </h5>
          <div class="collapse mt-4 pt-2" id="footer-general-info">
            <ClientOnly>
              <v-runtime-template
                :class="['cms-block-content more']"
                :template="`<div>` + unescape(generalInfoFooter.content) + `</div>`"
              ></v-runtime-template>
            </ClientOnly>
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-auto py-4  notice-info">
          <h5 class="d-none d-md-block">{{ brands.title }}</h5>
          <h5 class="d-block d-md-none">
            <a class="collapse-toggle d-flex justify-content-between align-items-center" data-toggle="collapse" href="#footer-notice" role="button" aria-expanded="false" aria-controls="footer-notice">
              <span>{{ brands.title }}</span>
              <ClientOnly><i class="fa-solid fa-angle-down"></i></ClientOnly>
            </a>
          </h5>
          <div class="collapse mt-4 pt-2" id="footer-notice">
            <ClientOnly>
              <v-runtime-template
                :class="['cms-block-content more']"
                :template="`<div>` + unescape(brands.content) + `</div>`"
              ></v-runtime-template>
            </ClientOnly>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg py-4 order-first order-lg-last footer-payment-section">
          <div class="d-flex justify-content-between align-items-center flex-lg-column align-items-lg-end gap-3 pt-lg-5">
            <img class="img-fluid" :src="imgUrl('webshop-trustmark.png')" alt="webshop trustmark">
            <img class="img-fluid" :src="imgUrl('payment-cards.png')" alt="payment cards">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VRuntimeTemplate from "v-runtime-template";
import getImageUrl from "@/esf_antarctica_lederhosenland/helpers/getImageUrl";
import cmsBlockSimple from "@/esf_antarctica_lederhosenland/core/components/common/BlockSimple.vue";
import ClientOnly from "vue-client-only";

export default {
  components: { cmsBlockSimple, VRuntimeTemplate, ClientOnly },

  computed: {
    brands() {
      return this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`](
        "footer_menu_quick_links"
      );
    },
    generalInfoFooter() {
      return this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`](
        "general_info_footer"
      );
    },
    footerData() {
     
      return [
        this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`](
          "footer_menu_information"
        ),
        this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`](
          "footer_menu_service"
        ),
        this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`](
          "footer_menu_quick_links"
        ),
      ];
    },
    contactData() {
      return this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`](
        "footer_contact"
      );
    },
  },
  methods: {
    imgUrl(filename) {
      return getImageUrl(filename);
    },
    unescape(str){
      return str.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
    }
  },
};
</script>

<style>
</style>